import { render, staticRenderFns } from "./production-icon.vue?vue&type=template&id=83ab66a2&scoped=true"
import script from "./production-icon.vue?vue&type=script&lang=js"
export * from "./production-icon.vue?vue&type=script&lang=js"
import style0 from "./production-icon.vue?vue&type=style&index=0&id=83ab66a2&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ab66a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83ab66a2')) {
      api.createRecord('83ab66a2', component.options)
    } else {
      api.reload('83ab66a2', component.options)
    }
    module.hot.accept("./production-icon.vue?vue&type=template&id=83ab66a2&scoped=true", function () {
      api.rerender('83ab66a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/recommended/production-icon.vue"
export default component.exports